import React, { useEffect } from 'react';
import BackToTopButton from '../components/BackToTopButton';
import { FaChartLine, FaBullhorn } from 'react-icons/fa';
import '../styles/global.css'; // Ensure this import is present for styles

function Insights() {
  useEffect(() => {
    const sections = document.querySelectorAll('.insight-section');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-active');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    sections.forEach(section => observer.observe(section));
  }, []);

  return (
    <div className="container mx-auto px-4 py-16">
      <h2 className="text-4xl font-semibold mb-4 text-gray-900 text-center">Market Insights</h2>

      <p className="text-lg text-gray-700 mb-8">
        The tax advisory industry is experiencing rapid changes driven by regulatory shifts, cross-border business growth, and increased demand for specialized knowledge. Here’s how CrossTax Advisors is positioning itself to address these market dynamics.
      </p>

      {/* Key Market Insights Section */}
      <section className="insight-section bg-gray-50 py-12 fade-in">
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-2xl font-semibold mb-8 text-gray-900">Key Market Insights</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-6 bg-white rounded-lg shadow-sm">
              <h4 className="text-3xl font-bold text-accent mb-2">75%</h4>
              <p className="text-gray-700">of US CPAs are expected to retire within the next 15 years, increasing demand for tax advisory services.</p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-sm">
              <h4 className="text-3xl font-bold text-accent mb-2">$56 Billion</h4>
              <p className="text-gray-700">Value of the global tax advisory market, with a growing demand for international expertise.</p>
            </div>
            <div className="p-6 bg-white rounded-lg shadow-sm">
              <h4 className="text-3xl font-bold text-accent mb-2">1000+</h4>
              <p className="text-gray-700">real estate tax transactions in the US, each with complex, jurisdiction-specific requirements.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="insight-section bg-gray-100 py-12 fade-in">
        <div className="container mx-auto px-4">
          <h3 className="text-2xl font-semibold text-gray-900 mb-6 text-center">Frequently Asked Questions</h3>
          <div className="space-y-4">
            <details className="bg-white p-4 border rounded shadow-sm">
              <summary className="font-semibold text-gray-900 cursor-pointer">What is cross-border tax advisory?</summary>
              <p className="mt-2 text-gray-600">Cross-border tax advisory involves managing tax obligations and compliance across different countries, ensuring tax efficiency while adhering to international regulations.</p>
            </details>
            <details className="bg-white p-4 border rounded shadow-sm">
              <summary className="font-semibold text-gray-900 cursor-pointer">Why choose a US-India tax specialist?</summary>
              <p className="mt-2 text-gray-600">A US-India tax specialist understands the intricacies of both tax systems, helping clients navigate complexities in cross-border transactions and compliance.</p>
            </details>
            <details className="bg-white p-4 border rounded shadow-sm">
              <summary className="font-semibold text-gray-900 cursor-pointer">How can CrossTax Advisors help my business?</summary>
              <p className="mt-2 text-gray-600">We offer customized tax solutions tailored to your unique needs, providing expertise in complex areas like real estate and international tax.</p>
            </details>
          </div>
        </div>
      </section>

      <BackToTopButton />
    </div>
  );
}

export default Insights;
